
import Header from "./Header";
import Footer from "./Footer";
import HeroSection from "./HeroSection";
import CTASection from "./CTASection";
import GuildlinePage from "./GuildlinePage";
import "../styles/lannding_page/lannding_page.css";

export default function LandingPage() {

    return (
        <div className="main">
            <Header className="main-header" />

            <HeroSection />
            <GuildlinePage />
            <CTASection />
            <Footer hideFooter={false} className="main-footer" />
        </div >


    );
}